import { RoleEnum } from '@zaoblako/shared/modules/security/enums/role.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** Role response body - DTO signature */
export interface RoleFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /** Role type */
  type: RoleEnum;
}

/** Role response body - DTO schema */
export const RoleFindDto = SerdeDtoClass.create<RoleFindInterface>(SecurityDtoKeysEnum.ROLE_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    sortable: true,
    serializer: yup.string(),
  },
  type: {
    label: 'Тип',
    sortable: true,
    serializer: yup
      .string()
      .oneOf(Object.values(RoleEnum)),
  },
});
